import { Location } from '@cobliteam/common-types';

import { lazy } from '@cobliteam/lazy-with-retries';

const SafetyDashboardPage = lazy(() => import('@cobliteam/safety-dashboard/src/pages/SafetyDashboardPage'));
const SafetyRankingDashboardPage = lazy(() => import('@cobliteam/safety-dashboard/src/pages/SafetyRankingDashboardPage'));

const routes = [
  {
    path: Location.SAFETY_RANKING_DASHBOARD,
    component: SafetyDashboardPage,
    accessDeniedDescription: 'ver ranking',
    team: 'video-xp',
    routes: [
      {
        path: Location.SAFETY_RANKING_DASHBOARD,
        component: SafetyRankingDashboardPage,
        accessDeniedDescription: 'ver ranking',
        exact: false,
        routes: [
          {
            path: Location.SAFETY_RANKING_DASHBOARD_VEHICLE_GROUP,
            accessDeniedDescription: 'ver ranking',
            exact: true,
          },
          {
            path: Location.SAFETY_RANKING_DASHBOARD_VEHICLE,
            accessDeniedDescription: 'ver ranking',
            exact: true,
          },
          {
            path: Location.SAFETY_RANKING_DASHBOARD_DRIVER,
            accessDeniedDescription: 'ver ranking',
            exact: true,
          },
        ],
      },
    ],
  },
];

export default routes;
